import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep';

import ActionLink from './ActionLink';
import ButtonCollection from './ButtonCollection';

export const ListContainer = ({ children, ...props }) => {
	let classes = [
		'gui_sortable_list',
		'gui_flexbox',
		'gui_flex_start',
		'gui_flex_col',
		'gui_flex_nowrap',
		'gui_overflowed_auto',
	];

	return (
		<ul class={classes.join(" ")} style={props?.style ?? null}>
			{children}
		</ul>
	)
};

export const ListItemWrapper = (props) => {
	return (
		<li class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center">
			{props.children}
		</li>
	)
};

const ListItemEmpty = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	return (
		<ListItemWrapper>
			<div class="item_header">
				<div class="item_title_container">
					<span class="item_title knk-off grayIcon">{props?.empty_message || i18n("There are no results.")}</span>
				</div>
			</div>
		</ListItemWrapper>
	)
};

export const ListItem = ({ item, ...props }) => {
	let title = '';
	if(typeof item.title == 'function') {
		title = item.title();
	} else if(item.title != undefined) {
		title = item.title;
	}

	return (
		<ListItemWrapper>
			<div class={"item_header"}>
				<div class="item_title_container">
					<ActionLink
						icon={`${(item?.icon ?? 'knk-arrow-r-big')} grayIcon`}
						_class={{other:'item_title cutTextOnOverflow gui_remove_pointer_events'}}
						autotranslate={false}
					>
						<strong>{title}</strong>
					</ActionLink>
				</div>

				{(props.actions != undefined) ? (
					React.cloneElement(props.actions(item), { item})
				) : (
					<ButtonCollection />
				)}
			</div>

			{(props.open != undefined && props.open(props.item)) && (
				<div class="gui_item_unfoldable_options">
					{React.cloneElement(props.element, { item:props.item })}
				</div>
			)}
		</ListItemWrapper>
	)
};

const ListItems = ({ items, ...props }) => {
	return (
		<ListContainer style={props.style}>
			{items.length > 0 && items.map((item, i) => (
				<ListItem
					key={i}
					item={item}
					actions={props.actions}
				/>
			))}

			{(items.length == 0) && (
				<ListItemEmpty
					empty_message={props.empty_message}
					intl={props.intl}
				/>
			)}
		</ListContainer>
	)
}

export default injectIntl(ListItems);